import React from "react";
import {
    ALLOWED_VALUES_CONTROL_TYPE_LABEL,
    ALLOWED_VALUES_CONTROL_TYPE_HINT,
    getDisplayControlType
} from "../../Common/allowedValuesQuestion";

export function AllowedValuesControlTypeLabel({ controlTypeName, isAllowedValuesQuestion }) {
    return (
        <>
            <span>{getDisplayControlType(controlTypeName, isAllowedValuesQuestion)}</span>
            {isAllowedValuesQuestion ? (
                <div className="max_char mt-1">{ALLOWED_VALUES_CONTROL_TYPE_HINT}</div>
            ) : null}
        </>
    );
}

export function AllowedValuesControlTypeSelect({
    isAllowedValuesQuestion,
    controlTypes,
    controlTypeId,
    onChange,
    disabled,
    error,
    wrapperClassName = "mb-3",
    required = true
}) {
    if (isAllowedValuesQuestion) {
        return (
            <div className={wrapperClassName}>
                <label htmlFor="allowedValuesControlType" className="form-label mb-0">
                    Control Type
                    {required ? <span className="required_field">*{error}</span> : null}
                </label>
                <input
                    type="text"
                    className="form-control"
                    id="allowedValuesControlType"
                    value={ALLOWED_VALUES_CONTROL_TYPE_LABEL}
                    readOnly
                    disabled
                />
                <span className="max_char">{ALLOWED_VALUES_CONTROL_TYPE_HINT}</span>
            </div>
        );
    }

    return (
        <div className={wrapperClassName}>
            <label htmlFor="ForminputState" className="form-label mb-0">
                Control Type
                {required ? <span className="required_field">*{error}</span> : null}
            </label>
            <select
                id="ForminputState"
                className="form-select"
                data-choices
                data-choices-sorting="true"
                disabled={disabled}
                value={controlTypeId || ""}
                onChange={onChange}
            >
                <option value="">Select Control</option>
                {controlTypes?.map((row) => (
                    <option key={row.id} value={row.id}>{row.name}</option>
                ))}
            </select>
        </div>
    );
}
